import React, { Component } from 'react'
import { connect } from 'react-redux'
import Slider from 'react-slick'
import * as actions from '../../redux/actions'

import Interface from '../../components/Interface'

import detectBrowserLanguage from 'detect-browser-language'
import text from '../../constants/Closet'

const resolveSectionType = type => {
  return {
    cartela: 'sheet',
    maquiagem: 'makeup',
    cabelo: 'hair',
    look: 'look',
    acessorios: 'accessories',
    contraste: 'contrast',
    trend: 'trending'
  }[type]
}

function listToMatrix (list, elementsPerSubArray) {
  let matrix = []
  let i
  let k

  for (i = 0, k = -1; i < list.length; i++) {
    if (i % elementsPerSubArray === 0) {
      k++
      matrix[k] = []
    }

    matrix[k].push(list[i])
  }

  return matrix
}

class ColoringMenuOption extends Component {
  constructor (props) {
    super(props)

    const sectionType = resolveSectionType(this.props.match.params.type)
    if (!sectionType) {
      // Section type does not exist
      this.props.history.push('/')
    }

    this.state = {
      page: 0,
      settings: {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        afterChange: index => this.setState({ page: index }),
        nextArrow: <img src='/assets/next-button.svg' alt='Next Button' />,
        prevArrow: <img src='/assets/prev-button.svg' alt='Back Button' />
      },
      language: 1,
      sectionType
    }
  }

  async componentWillMount () {
    if (!localStorage.getItem('language')) {
      if (
        detectBrowserLanguage() === 'pt-BR' ||
        detectBrowserLanguage() === 'pt-PT' ||
        detectBrowserLanguage() === 'pt' ||
        detectBrowserLanguage().slice(0, 2) === 'pt'
      ) {
        this.setState({ language: 0 })
        localStorage.setItem('language', '0')
      }
      if (detectBrowserLanguage().slice(0, 2) === 'es') {
        this.setState({ language: 2 })
        localStorage.setItem('language', '2')
      }
    } else {
      this.setState({ language: localStorage.getItem('language') - '0' })
    }
  }

  renderSection = (sectionInfo, idx) => {
    const mapArray = listToMatrix(sectionInfo.items, 2)
    return (
      <div className='category-carousel-wrapper'>
        <div key={idx} className='coloring-category-carousel'>
          <div className='coloring-category-item'>
            <div className='coloring-category-item-title'>
              {sectionInfo.title}
            </div>
            {sectionInfo.description && (
              <div>
                <div className='coloring-category-item-subtitle'>
                  {sectionInfo.description}
                </div>
              </div>
            )}
          </div>
          <div className='coloring-category-content'>
            {mapArray.slice(0, 2).map(line => <div style={{ width: '100%', display: 'inline-block' }}> {
              line.map(item => {
                return (
                  <div
                    className={`coloring-category-item-image length-${
                      sectionInfo.items.length
                    }`}
                  >
                    <a href={item.link ? item.link.indexOf('http') === -1 ? `http://${item.link}` : item.link : '#'} style={{ display: 'block', position: 'relative' }}>
                      {item.link ? <img src={process.env.PUBLIC_URL + '/assets/shopping-bag.png'} alt='bolsa' className='coloring-category-shopping-bag' /> : ''}
                      <img src={item.image} alt={item.description} />
                      {item.description ? (
                        <div className='coloring-category-item-description'>
                          {item.description}
                        </div>
                      ) : null}
                    </a>
                  </div>
                )
              })}
            </div>
            )}
          </div>
        </div>
      </div>
    )
  };

  render () {
    const { page } = this.state

    const allSections =
      this.props.user.personalColoringSections &&
      this.props.user.personalColoringSections[this.state.sectionType]

    return (
      <Interface
        logoImg='assets/coloracao.png'
        title={this.props.match.params.type}
        history={this.props.history}
      >
        <div id='carousel' className='color-category-carousel'>
          {allSections && allSections.length > 0 ? (
            <div>
              <Slider {...this.state.settings}>
                {allSections.map(this.renderSection)}
              </Slider>
              <div id='page'>
                {page + 1} {text.of[this.state.language]} {allSections.length}
              </div>
            </div>
          ) : (
            <div id='listaText'>
              <span>{text.notConfig[this.state.language]}</span>
            </div>
          )}
        </div>
      </Interface>
    )
  }
}

const mapStateToProps = state => {
  return {
    ...state.userReducer,
    products: state.productsReducer
  }
}

export default connect(
  mapStateToProps,
  actions
)(ColoringMenuOption)



// WEBPACK FOOTER //
// ./src/containers/Cromatica/ColoringMenuOption.js